module.exports = __webpack_public_path__ + "img/4.00a863b6.jpeg";